/* ----------------------------------------------------------
Import Modules
---------------------------------------------------------- */

import CRMController from './classes/crm-controller';
import NZBNController from './classes/nzbn-controller';
import TriageFormController from './classes/form-controller';
import TriageStepsController from './classes/steps-controller';
import TriageFormPathwayController from './classes/pathway-controller';

/* -------------------------------------------------------
Constants
------------------------------------------------------- */

// TODO: Make this CMSable?
const CUSTOMER_TYPE = 'triage_customer_type';

// THESE ARE ALL CUSTOM TRIAGE FIELD NAMES AND DONT NEED TO MATCH THE CRM
const TIMESTAMP = 'Timestamp';
const RECIPIENTS = 'custom_triage_field_recipients';
const EMAIL_SUBJECT = 'custom_triage_field_email_subject';
const EMAIL_TEMPLATE = 'custom_triage_field_email_template';
const EMAIL_CONTENT = 'custom_triage_field_email_content';
const NZBN_LOOKUP = 'custom_triage_field_nzbn_lookup';
const NZBN_RESULT = 'custom_triage_field_nzbn_result';
const NZBN_RESULT_LIST = 'custom_triage_field_nzbn_result';
const SUBSCRIBE_TO_NEWSLETTER = 'custom_triage_field_subscribe';
const ACCEPT_TERMS = 'custom_triage_field_acceptance';
const USER_REVIEW = 'custom_triage_field_rating';
const USER_COMMENTS = 'custom_triage_field_comments';

/* -------------------------------------------------------
Data
------------------------------------------------------- */

// Grab the triage form array data from the window
const TRIAGE_DATA_ARRAY = window.TriageForms;
// The submission URL
const SUBMISSION_URL = '/api/triage_submit';
// Create a new XHR request to send the form data
const XHR = new XMLHttpRequest();

/* -------------------------------------------------------
Window Variables / Controllers
------------------------------------------------------- */

window.CRMLookup = new CRMController();
window.NZBNLookup = new NZBNController();

/* -------------------------------------------------------
Functions
------------------------------------------------------- */

function handleTriageFormSubmission() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let TriageForm = arguments.length > 1 ? arguments[1] : undefined;
  // Enable the button if not successful
  data.button.disabled = !data.success;

  // Destroy the form if successful
  if (data.success) TriageForm.destroy();

  // Create a new p tag to hold the form messages in the form
  TriageForm.message = TriageForm.addHTML('<p class="message"></p>');

  // Reset the message class
  TriageForm.message.className = 'message';

  // Set the message and class based on success
  TriageForm.message.innerHTML = data.message;
  TriageForm.message.classList.add(data.success ? 'success' : 'error');

  // PageSense tracking
  window.pagesense = window.pagesense || [];
  window.pagesense.push(['trackEvent', 'TriageSubmit']);
}
function formatYmdHisu(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const H = String(date.getHours()).padStart(2, '0');
  const i = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  const u = String(date.getMilliseconds()).padStart(3, '0');
  return `${y}${m}${d}${H}${i}${s}${u}`;
}

// A function to submit the triage form
function submitTriageForm(data, Triage) {
  // Grab the Triage Components
  const {
    TriageForm,
    TriageSteps,
    TriageNavigator
  } = Triage;

  // Disable the button
  data.button.disabled = true;

  // Add a timestamp to the form before submitting
  TriageForm.addHiddenInput({
    id: TIMESTAMP,
    name: TIMESTAMP,
    // set the value to YmdHisu
    value: formatYmdHisu(new Date())
  });

  // About any previous requests
  XHR.abort();
  // Open the request
  XHR.open('POST', SUBMISSION_URL, true);
  // Set the request headers
  XHR.setRequestHeader('Content-Type', 'application/json');

  // When the request is loaded
  XHR.onload = () => {
    if (XHR.status >= 200 && XHR.status < 300) {
      let message = '';
      try {
        message = JSON.parse(XHR.responseText).data.message;
      } catch (error) {
        message = 'Thank you for your submission.';
        console.error('Error parsing response', error);
      }

      // Call the submit event on the navigator
      TriageNavigator.submit();
      handleTriageFormSubmission({
        button: data.button,
        success: true,
        message
      }, TriageForm);
    } else {
      console.error('Error', XHR.responseText);
      handleTriageFormSubmission({
        button: data.button,
        success: false,
        message: 'There was an error submitting the form. Please try again.'
      }, TriageForm);
    }
  };

  // When the request has an error
  XHR.onerror = () => {
    console.error('Error', XHR.responseText);
    handleTriageFormSubmission({
      button: data.button,
      success: false,
      message: 'There was an error submitting the form. Please try again.'
    }, TriageForm);
  };

  // Send the request
  XHR.send(TriageForm.getJSONString());
}

/* -------------------------------------------------------
Proccess the Triage Form Blocks
------------------------------------------------------- */

function renderTriageBlock(block, BLOCK_DATA) {
  // Find the form and content containers
  const containers = {
    form: block.querySelector('.js-default-triage__form'),
    content: block.querySelector('.js-default-triage__content'),
    summary: block.querySelector('.js-default-triage__summary'),
    decisions: block.querySelector('.js-default-triage__decisions'),
    first_step: block.querySelector('.js-default-triage__first-step')
  };

  // Find the progress bar
  const progress = block.querySelector('.js-default-triage__progress');

  // Create a new Triage Form Controller to handle the form fields
  const TriageForm = new TriageFormController({
    id: block.id + '_Form',
    novalidate: true
  });

  // Create a new triage steps controller to display the fieldsets
  const TriageSteps = new TriageStepsController();

  // Create a new triage form pathway controller to navigate the form
  const TriageNavigator = new TriageFormPathwayController({
    blockID: block.id,
    ...BLOCK_DATA
  }, {
    // Map the data keys to our more readable pathway keys (make sure you also add new keys to the pathway controller class)
    id: 'id',
    legend: 'legend',
    pathway: 'pathway',
    pathways: 'pathways',
    progress: 'progress',
    recipients: 'recipients',
    email_subject: 'email_subject',
    email_template: 'email_template',
    email_content: 'email_content',
    api_response: 'api_response',
    pathway_name: 'name',
    pathway_type: 'type',
    pathway_forks: 'forks',
    pathway_title: 'title',
    pathway_content: 'content',
    pathway_nzbn_name: 'nzbn_name',
    pathway_fieldsets: 'fieldsets',
    pathway_information: 'information',
    pathway_summary_fields: 'summary_fields',
    submission_heading: 'submission_heading'
  });

  // The email recipients will be populated on this field later on
  const HiddenField_Recipients = TriageForm.addHiddenInput({
    id: RECIPIENTS,
    name: RECIPIENTS
  });

  // The email subject will be populated on this field later on
  const HiddenField_EmailSubject = TriageForm.addHiddenInput({
    id: EMAIL_SUBJECT,
    name: EMAIL_SUBJECT
  });

  // The email template will be populated on this field later on
  const HiddenField_EmailTemplate = TriageForm.addHiddenInput({
    id: EMAIL_TEMPLATE,
    name: EMAIL_TEMPLATE
  });

  // The email content will be populated on this field later on
  const HiddenField_EmailContent = TriageForm.addHiddenInput({
    id: EMAIL_CONTENT,
    name: EMAIL_CONTENT
  });

  // Store an array of pathway decisions here
  const PATHWAY_DECISIONS = {};

  // A function to render the pathway decisions in the DOM
  const renderPathwayDecisions = () => {
    containers.decisions.innerHTML = '';

    // Loop the pathway decisions
    Object.keys(PATHWAY_DECISIONS).forEach((key, i) => {
      // Grab the key's value
      const value = PATHWAY_DECISIONS[key];

      // The first step is a special case
      if (i === 0) {
        // Reset the containers
        containers.first_step.innerHTML = '';
        // If there is no summary value, return
        if (!value) return;
        // Add the decision to the first step container
        containers.first_step.innerHTML = `<span class="triage-form__decision">${value}</span>`;
      }

      // The others all sit in the decisions container
      else {
        // If there is no summary value, return
        if (!value) return;
        // Add the decision to the decisions container
        containers.decisions.innerHTML += `<span class="triage-form__decision">${value}</span>`;
      }
    });
  };

  // When the form validates, scroll to any invalid fields
  TriageForm.on('validate', data => {
    // If the form is valid, do nothing
    if (data.valid) return;

    // The invalidated array is populated with field names, so let's find the first one
    let invalid = document.querySelector(`[name="${data.invalidated[0]}"]`);
    let parent = invalid.parentNode;

    // invalid.focus();

    window.ScrollController.scrollTo(Meteora.offset(parent).y - 200);
  });

  // Handle the form submission
  TriageForm.on('submit', data => submitTriageForm(data, {
    TriageForm,
    TriageSteps,
    TriageNavigator
  }));

  // When we go to a step, toggle the current step class
  TriageSteps.on('goto', response => {
    // Grab the element from the data object
    const element = response.element;
    // Grab the FieldsetSteps from the response
    const FieldsetSteps = response.FieldsetSteps;

    // If the response has a FieldsetSteps, go to the first Fieldset step
    if (FieldsetSteps) FieldsetSteps.goto(FieldsetSteps.index);

    // Loop the fieldsets and toggle the current step class
    TriageSteps.elements.forEach(fieldset => {
      fieldset.classList.toggle('current-step', fieldset === element);
    });
  });

  // When we go back a step, tell the navigator to go back
  TriageSteps.on('back', () => TriageNavigator.back());

  // Each time pathways are trimmed, we need to trim the pathway decisions
  TriageSteps.on('trim', data => {
    // Loop the array of removed steps
    data.removed.forEach(step => {
      // If the step is in the pathway decisions, remove it
      if (PATHWAY_DECISIONS[step]) delete PATHWAY_DECISIONS[step];
    });
    renderPathwayDecisions();
  });

  // If the step is removed, remove the element from the DOM
  TriageSteps.on('remove', data => data.element.remove());

  // When the navigator renders it's data, we can create the form elements
  TriageNavigator.on('render', data => {
    // Create a new Path ID
    const pathID = 'PathID_' + data.id;

    // Set the step attribute on the block
    block.setAttribute('data-step', data.step);
    renderPathwayDecisions();

    // Try and go to an existing group, otherwise create a new one, and trim the progress to the current position
    // This allows the user to traverse back and forth (unless they change their pathway) through the form.
    TriageSteps.goto(pathID).catch(() => {
      // Remove the future progress
      TriageSteps.trim();

      // Grab the forks
      const forks = data.pathway_forks;
      // Grab the fieldsets and sort them
      const fieldsets = data.pathway_fieldsets.sort((a, b) => a.sort - b.sort);
      // Create a new group element to hold this pathway's fieldsets etc
      const FormGroup_Pathway = TriageForm.addGroup(pathID);

      // Create a new steps controller to handle the fieldsets
      const FieldsetSteps = new TriageStepsController();

      // Simple boolean checks
      const HAS_CUSTOM_FORM_FIELD_GROUPS = fieldsets.length > 0;
      const HAS_PROGRESS = TriageSteps.progress.length > 0;

      // Pathway type checks
      const TYPE_IS_CRM = data.pathway_type === 'crm';
      const TYPE_IS_NZBN = data.pathway_type === 'nzbn';
      const TYPE_IS_CHOICE = data.pathway_type === 'choice';
      const TYPE_IS_CONTENT = data.pathway_type === 'content';
      const TYPE_IS_SUBMISSION = data.pathway_type === 'submission';

      // When we go to a step, toggle the current step class
      FieldsetSteps.on('goto', response => {
        // Grab the element from the data object
        const element = response.element;
        // Grab the content from the response
        const content = TriageNavigator.get('pathway_content', response.data);
        // Grab the offset from the element
        const offset = Math.max(Meteora.offset(element).y - 100, 0);

        // Make sure the progress bar exists
        if (progress) progress.style.width = `${response.data.progress}%`;
        if (content) {
          // Determine where to place the content
          if (TYPE_IS_CONTENT) {
            // Add the content to the form
            TriageForm.addHTML(content, pathID);
          } else {
            // Add the content to the content container
            containers.content.innerHTML = content;
          }
        } else {
          // If there is no content, clear the content container
          containers.content.innerHTML = '';
        }

        // We only want to show the summary container if the pathway type is 'submission'
        containers.summary.classList.toggle('hidden', !TYPE_IS_SUBMISSION);

        // Loop the fieldsets and toggle the current step class
        FieldsetSteps.elements.forEach(fieldset => {
          fieldset.classList.toggle('current-step', fieldset === element);
        });
        setTimeout(() => {
          if (window.scrollY > offset) window.ScrollController.scrollTo(offset);
        }, 100);
      });

      // Loop the fieldsets
      fieldsets.forEach((fieldsetData, fieldsetDataIndex) => {
        // Grab the fields
        const fieldDataArray = fieldsetData.fields;
        // Create a new holder element for the fieldset
        const fieldset = document.createElement('fieldset');
        // Create a next and previous button
        const nextButton_fieldsets = document.createElement('button');
        const backButton_fieldsets = document.createElement('button');

        // Some simple boolean checks
        const IS_FIRST_FIELDSET = fieldsetDataIndex === 0;
        const IS_LAST_FIELDSET = fieldsetDataIndex === fieldsets.length - 1;
        const HAS_FORKS = forks.length > 0;

        // Set the fieldset's ID
        fieldset.id = `Fieldset_${fieldsetData.id}`;

        // Set up the next and back buttons
        nextButton_fieldsets.innerHTML = 'Next';
        backButton_fieldsets.innerHTML = 'Back';
        nextButton_fieldsets.classList.add('button', 'b-secondary', 'triage-form__next');
        backButton_fieldsets.classList.add('button', 'triage-form__back');

        // Add this fieldset to the form group
        FieldsetSteps.add({
          id: fieldset.id,
          element: fieldset,
          data: fieldsetData
        });

        // If this is the first fieldset, we need to go to the group
        if (fieldsetDataIndex === 0) FieldsetSteps.goto(fieldset.id);

        // Add this new fieldset to the group
        FormGroup_Pathway.appendChild(fieldset);

        // Each field has a sort order, let's sort them
        fieldDataArray.sort((a, b) => a.sort - b.sort);

        // Loop the fields
        fieldDataArray.forEach(field => {
          // If the field is just info, simply add it to the fieldset and return
          if (field.type === 'information') {
            const HTML_Info = TriageForm.addHTML('<div class="triage-form__information">' + field.information + '</div>', pathID);
            fieldset.appendChild(HTML_Info);
            return;
          }

          // If the field is a heading, simply add it to the fieldset and return
          if (field.type === 'heading') {
            const HTML_Heading = TriageForm.addHTML('<span class="triage-form__heading">' + field.heading + '</span>', pathID);
            fieldset.appendChild(HTML_Heading);
            return;
          }

          // If the field has a "find_value" attribute, we will try to find the value from another field (by name)
          if (field.find_value) {
            // Grab the field by name
            const FieldByName = TriageForm.getFieldByName(field.find_value);
            if (FieldByName) field.value = FieldByName.getValue();
          }

          // Create a new form element
          const FormField = TriageForm.parse(field, pathID);

          // Set up a custom label for the field if it is a checkbox or radio
          if (field.type === 'checkbox' || field.type === 'radio') {
            // Bool to change the optionset styles based on the content
            let CONTAINS_DESCRIPTIONS_OR_NOTES = false;
            field.options.forEach((option, index) => {
              // Grab the appropriate option
              const Option = FormField.options[index];

              // Set an outline class on the field
              // Option.field.classList.add('outlined');

              // Set the bool to true if the option has a description or notes
              if (option.description || option.notes) CONTAINS_DESCRIPTIONS_OR_NOTES = true;

              // Set a new label for the option
              Option.setLabel(`
                <span class="label">${option.label ? option.label : ''}</span>
                <span class="description">${option.description ? option.description : ''}</span>
                <span class="notes">${option.notes ? option.notes : ''}</span>
              `);
            });
            if (CONTAINS_DESCRIPTIONS_OR_NOTES) FormField.field.classList.add('emphasis');
          }

          // If the field is a tooltip, inject the tooltip before the label
          if (field.tooltip != '') {
            console.log('field', FormField);
            // Create a new tooltip passing in the tooltip html
            const Tooltip = TriageForm.addTooltip(field.tooltip);
            // Insert the tooltip before the field label
            FormField.field.insertBefore(Tooltip.container, FormField.label.nextElementSibling);
          }

          // Add the created element to the fieldset
          fieldset.appendChild(FormField.field);
        });

        // If there is a previous fieldset or a previous step, add the back button
        if (!IS_FIRST_FIELDSET || HAS_PROGRESS) {
          // Add the back button to the fieldset
          fieldset.appendChild(backButton_fieldsets);

          // Prevent the default action of the back button
          backButton_fieldsets.addEventListener('click', e => e.preventDefault());

          // If this is the first fieldset, the back button will take us to the previous TriageSteps step
          if (IS_FIRST_FIELDSET) backButton_fieldsets.addEventListener('click', () => TriageSteps.back());

          // Otherwise, the back button will take us to the previous fieldset
          else backButton_fieldsets.addEventListener('click', () => FieldsetSteps.back());
        }

        // We only want to add the next button if there is another fieldset or a next pathway
        // We are currently dealing with fieldsets on the pathway, so we will always need to be able to go to the next step if the pathway type is 'submission'
        if (!IS_LAST_FIELDSET || HAS_FORKS || TYPE_IS_SUBMISSION) {
          // Add the next button to the fieldset
          fieldset.appendChild(nextButton_fieldsets);

          // Set up the next button to go to the next fieldset when clicked
          nextButton_fieldsets.addEventListener('click', e => {
            e.preventDefault();
            const valid = TriageForm.validate(fieldset);
            if (!valid) return;
            FieldsetSteps.next();
          });
        }
      });

      // Create a new fieldset element to hold the optionset
      const pathwayFieldset = document.createElement('fieldset');

      // Set an ID on this fieldset
      pathwayFieldset.id = `Fieldset_ID_${data.id}_Forks`;
      // Add the fieldset to the group
      FormGroup_Pathway.appendChild(pathwayFieldset);

      // Create next, back and submit button elements
      const nextButton_forks = document.createElement('button');
      const backButton_forks = document.createElement('button');
      const submitButton = document.createElement('button');

      // Set up the buttons
      nextButton_forks.innerHTML = 'Next';
      backButton_forks.innerHTML = 'Back';
      submitButton.innerHTML = 'Submit';
      nextButton_forks.classList.add('triage-form__next', 'button', 'b-secondary');
      backButton_forks.classList.add('triage-form__back', 'button');
      submitButton.classList.add('triage-form__submit', 'button', 'action');
      if (TYPE_IS_CHOICE) {
        if (forks.length) {
          // Create a new Optionset
          const OptionsetField_Forks = TriageForm.addOptionset(data, pathID);

          // Add the optionset to the fieldset
          pathwayFieldset.appendChild(OptionsetField_Forks.field);
          if (data.pathway_information) {
            // Create a new information element
            const HTML_Info = TriageForm.addHTML('<div class="triage-form__information">' + data.pathway_information + '</div>', pathID);
            // Load the element into the fieldset
            pathwayFieldset.appendChild(HTML_Info, pathID);
          }

          // Add the next button to the fieldset
          pathwayFieldset.appendChild(nextButton_forks);

          // Sort the forks
          forks.sort((a, b) => a.sort - b.sort);

          // Loop the forks
          forks.forEach(fork => {
            // Sort the options
            fork.options.sort((a, b) => a.sort - b.sort);
            // Loop the options for this fork
            fork.options.forEach(data => {
              // Create a new option we can add events to
              const Option_Fork = OptionsetField_Forks.addOption({
                ...data,
                attributes: {
                  required: true
                }
              });
              Option_Fork.setLabel(`
                <span class="label">${data.label ? data.label : ''}</span>
                <span class="description">${data.description ? data.description : ''}</span>
                <span class="notes">${data.notes ? data.notes : ''}</span>
              `);

              // Grab the summary text and add it to the option
              // Option_Fork.summary_text = data.summary_text;

              // When the Option is changed, set the next pathway to the fork's callback
              Option_Fork.on('change', () => {
                // Assign this fork to the pathway decisions
                PATHWAY_DECISIONS[pathID] = data.summary_text;
                nextButton_forks.setAttribute('data-pathway', fork.value);
                nextButton_forks.callback = fork.callback;
              });
            });

            // Add the special emphasis class to the fieldset for styles
            OptionsetField_Forks.field.classList.add('emphasis');
          });
        }

        // When the next button is clicked, call the next pathway
        nextButton_forks.addEventListener('click', e => {
          e.preventDefault();

          // Validate the form
          const valid = TriageForm.validate(pathwayFieldset);
          // If the form is not valid, return
          if (!valid) return;
          // If there is a next pathway, call it
          if (nextButton_forks.callback && typeof nextButton_forks.callback === 'function') nextButton_forks.callback();
        });
      }
      if (TYPE_IS_NZBN) {
        // Create a timeout to prevent too many requests
        let timeout = null;
        let cache = '';

        // Create a new Lookup field
        const TextField_NZBNLookup = TriageForm.addTextInput({
          id: NZBN_LOOKUP,
          type: 'text',
          label: data.legend,
          name: NZBN_LOOKUP,
          attributes: {
            required: true,
            placeholder: 'Search for your business',
            title: 'Search for your business'
          }
        }, pathID);
        const OptionsetField_NZBN = TriageForm.addOptionset({
          id: NZBN_RESULT_LIST,
          legend: 'Select your business from the list below',
          type: 'radio',
          attributes: {
            required: true
          }
        }, pathID);
        const HiddenField_CustomerType = TriageForm.addHiddenInput({
          id: CUSTOMER_TYPE,
          name: CUSTOMER_TYPE
        }, pathID);
        const HiddenField_NZBNText = TriageForm.addHiddenInput({
          id: data.pathway_name,
          name: data.pathway_name
        }, pathID);
        const HiddenField_NZBNName = TriageForm.addHiddenInput({
          id: data.pathway_nzbn_name,
          name: data.pathway_nzbn_name
        }, pathID);

        // Disable the next button until we have a valid NZBN response
        nextButton_forks.disabled = true;
        pathwayFieldset.appendChild(HiddenField_CustomerType.field);

        // When the user selects a business, we will set the NZBN and name fields
        OptionsetField_NZBN.on('change', value => {
          const [name, nzbn] = value.split(': ');
          HiddenField_NZBNText.setValue(nzbn);
          HiddenField_NZBNName.setValue(name);
        });

        // Reset the NZBN lookup events
        window.NZBNLookup.reset();

        // When the user searches, we will add a loading class to the field
        window.NZBNLookup.on('search', () => {
          TextField_NZBNLookup.field.classList.add('loading');
        });
        window.NZBNLookup.on('check', () => {
          containers.form.classList.add('loading');
        });
        window.NZBNLookup.on('search:success', apiResponse => {
          // Parse the response to get the data
          apiResponse = JSON.parse(apiResponse).data;

          // Remove the loading class from the field
          TextField_NZBNLookup.field.classList.remove('loading');

          // Empty the optionset
          OptionsetField_NZBN.empty();

          // Loop the businesses
          apiResponse.items.forEach((business, i) => {
            // Just return 5 results
            if (i >= 5) return;

            // Create a new option element
            const Option_NZBN = OptionsetField_NZBN.addOption({
              id: NZBN_RESULT + '__' + i,
              name: NZBN_RESULT,
              value: business.entityName + ': ' + business.nzbn
            });
            Option_NZBN.setLabel(`
              <span class="label">${business.entityName}</span>
              <span class="description">NZBN: ${business.nzbn}</span>
            `);

            // Set an outline class on the field
            Option_NZBN.field.classList.add('nzbn');
          });

          // Add the special emphasis class to the fieldset for styles
          OptionsetField_NZBN.field.classList.add('emphasis');
          OptionsetField_NZBN.on('change', () => {
            nextButton_forks.disabled = !OptionsetField_NZBN.getValue();
          });
        });

        // Once the user's NZBN has been validated against the CRM, we will know if they are an existing customer or not
        window.NZBNLookup.on('check:success', r => {
          const response = JSON.parse(r).data;
          const validity = response.result || 'false';
          containers.form.classList.remove('loading');

          // Set the customer type value
          HiddenField_CustomerType.setValue(response[CUSTOMER_TYPE] || 'New Customer');

          // Select the pathway based on the validity
          data.api_response[validity].callback();
        });
        window.NZBNLookup.on('check:error', () => {
          // Select the pathway based on the validity
          data.nzbn['false'].callback();
        });

        // When the search field changes in value, we will search for the NZBN using the API
        TextField_NZBNLookup.on('change', value => {
          clearTimeout(timeout);
          nextButton_forks.disabled = true;
          if (value === '') return OptionsetField_NZBN.empty();
          timeout = setTimeout(() => {
            if (cache === value) return;
            cache = value;
            window.NZBNLookup.search(value);
          }, 500);
        });

        // Add the Lookup field to the fieldset
        pathwayFieldset.appendChild(TextField_NZBNLookup.field);
        pathwayFieldset.appendChild(OptionsetField_NZBN.field);
        if (data.pathway_information) {
          // Create a new information element
          const HTML_Info = TriageForm.addHTML('<div class="triage-form__information">' + data.pathway_information + '</div>', pathID);
          // Load the element into the fieldset
          pathwayFieldset.appendChild(HTML_Info, pathID);
        }

        // Add the next button to the fieldset
        pathwayFieldset.appendChild(nextButton_forks);

        // When the next button is clicked, call the next pathway
        nextButton_forks.addEventListener('click', e => {
          e.preventDefault();
          // Now check the NZBN against the CRM
          window.NZBNLookup.check(encodeURIComponent(OptionsetField_NZBN.getValue()));
        });
      }
      if (TYPE_IS_CRM) {
        // Create a new Lookup field
        const TextField_CRMLookup = TriageForm.addTextInput({
          id: data.pathway_name,
          type: 'text',
          label: data.legend,
          name: data.pathway_name,
          attributes: {
            required: true,
            placeholder: 'Your business name',
            title: 'Enter your business name'
          }
        }, pathID);

        // This hidden field will be populated based on the CRM response
        const HiddenField_CustomerType = TriageForm.addHiddenInput({
          id: CUSTOMER_TYPE,
          name: CUSTOMER_TYPE
        }, pathID);

        // Disable the next button until we have a valid NZBN response
        nextButton_forks.disabled = true;

        // Add the customer type field to the fieldset
        pathwayFieldset.appendChild(HiddenField_CustomerType.field);
        // Add the Lookup field to the fieldset
        pathwayFieldset.appendChild(TextField_CRMLookup.field);

        // Reset the CRM lookup events
        window.CRMLookup.reset();

        // When the user searches, we will add a loading class to the field
        window.CRMLookup.on('check', () => {
          containers.form.classList.add('loading');
        });

        // Once the user's NZBN has been validated against the CRM, we will know if they are an existing customer or not
        window.CRMLookup.on('check:success', r => {
          const response = JSON.parse(r).data;
          const validity = response.result || 'false';
          containers.form.classList.remove('loading');

          // Set the customer type value
          HiddenField_CustomerType.setValue(response[CUSTOMER_TYPE] || 'New Customer');

          // Select the pathway based on the validity
          data.api_response[validity].callback();
        });
        window.CRMLookup.on('check:error', () => {
          // Select the pathway based on the validity
          data.nzbn['false'].callback();
        });

        // When the search field changes in value, we will search for the NZBN using the API
        TextField_CRMLookup.on('change', value => {
          nextButton_forks.disabled = value === '';
        });
        if (data.pathway_information) {
          // Create a new information element
          const HTML_Info = TriageForm.addHTML('<div class="triage-form__information">' + data.pathway_information + '</div>', pathID);
          // Load the element into the fieldset
          pathwayFieldset.appendChild(HTML_Info, pathID);
        }

        // Add the next button to the fieldset
        pathwayFieldset.appendChild(nextButton_forks);

        // When the next button is clicked, call the next pathway
        nextButton_forks.addEventListener('click', e => {
          e.preventDefault();
          // Now check the value against the CRM
          window.CRMLookup.check(TextField_CRMLookup.getValue());
        });
      }
      if (TYPE_IS_SUBMISSION) {
        const {
          terms_label,
          terms_content,
          // subscription_label,
          // subscription_content,
          reviews_label,
          comments_label
        } = window.submissions_fields;
        const summary_fields = data.pathway_summary_fields;
        let HTML_Heading = null;
        let OptionsetField_Acceptance = null;
        let HTML_AcceptanceContent = null;
        // let OptionsetField_Subscribe = null;
        // let HTML_SubscribeContent = null;

        // Create a new heading element
        if (data.submission_heading) {
          HTML_Heading = TriageForm.addHTML('<span class="triage-form__heading">' + data.submission_heading + '</span>', pathID);
        }

        // Create a terms and conditions checkbox
        OptionsetField_Acceptance = TriageForm.addOptionset({
          id: ACCEPT_TERMS,
          name: ACCEPT_TERMS,
          type: 'checkbox',
          attributes: {
            required: true
          },
          options: [{
            value: 'true',
            label: terms_label || 'I accept the terms and conditions'
          }]
        }, pathID);
        if (terms_content) {
          HTML_AcceptanceContent = TriageForm.addHTML('<div class="triage-form__help">' + terms_content + '</div>');
        }

        // Create a subscribe checkbox
        // OptionsetField_Subscribe = TriageForm.addOptionset({
        //   id: SUBSCRIBE_TO_NEWSLETTER,
        //   name: SUBSCRIBE_TO_NEWSLETTER,
        //   type: 'checkbox',
        //   options: [
        //     {
        //       value: 'true',
        //       label: subscription_label || 'Subscribe to our newsletter',
        //     },
        //   ],
        // }, pathID);

        // if (subscription_content) {
        //   HTML_SubscribeContent = TriageForm.addHTML('<div class="triage-form__help">' + subscription_content + '</div>');
        // }

        // Create a new optionset where the user can rate the form
        const StarRatingField_UserReview = TriageForm.addStarRating({
          id: USER_REVIEW,
          name: USER_REVIEW,
          legend: reviews_label || 'How would you rate this form?',
          attributes: {
            required: true
          }
        }, pathID);

        // Create a new textarea where the user can leave comments
        const TextareaField_UserComments = TriageForm.addTextareaInput({
          id: USER_COMMENTS,
          name: USER_COMMENTS,
          label: comments_label || 'Comments'
        }, pathID);

        // Add the new fields to the fieldset
        if (HTML_Heading) pathwayFieldset.appendChild(HTML_Heading);
        pathwayFieldset.appendChild(OptionsetField_Acceptance.field);
        if (HTML_AcceptanceContent) pathwayFieldset.appendChild(HTML_AcceptanceContent);

        // pathwayFieldset.appendChild(OptionsetField_Subscribe.field);
        // if (HTML_SubscribeContent) pathwayFieldset.appendChild(HTML_SubscribeContent);

        pathwayFieldset.appendChild(StarRatingField_UserReview.field);
        pathwayFieldset.appendChild(TextareaField_UserComments.field);
        if (data.pathway_information) {
          // Create a new information element
          const HTML_Info = TriageForm.addHTML('<div class="triage-form__information">' + data.pathway_information + '</div>', pathID);
          // Load the element into the fieldset
          pathwayFieldset.appendChild(HTML_Info, pathID);
        }

        // Add the submit button to the fieldset
        pathwayFieldset.appendChild(submitButton);

        // If there are recipients in the data, set the recipients field to the value or an empty string
        HiddenField_Recipients.setValue(data.recipients ?? '');
        // If there is an email subject in the data, set the email subject field to the value or an empty string
        HiddenField_EmailSubject.setValue(data.email_subject ?? '');
        // If there is an email template in the data, set the email template field to the value or an empty string
        HiddenField_EmailTemplate.setValue(data.email_template ?? '');
        // If there is an email content in the data, set the email content field to the value or an empty string
        HiddenField_EmailContent.setValue(data.email_content ?? '');

        // Clear the summary container to prevent old data from showing ifthe users changes their details
        containers.summary.innerHTML = '';

        // Add the summary fields to the summary container
        summary_fields.forEach(fieldJSON => {
          // Find the field in the Triage Form
          const Field = TriageForm.getFieldByName(fieldJSON.name);
          const summary = document.createElement('span');

          // If there is no field, return
          if (!Field) return;

          // Set the class on the summary
          summary.classList.add('triage-form__summary');

          // A function to update the summary
          const updateSummary = () => {
            /* No longer need to show the label
            summary.innerHTML = Field.getLabel() + ': ' + Field.getValue();
            Just show the value */
            summary.innerHTML = Field.getValue();
            summary.style.display = Field.getValue() === '' ? 'none' : '';
          };

          // Every time the field changes, update the summary
          Field.on('change', () => updateSummary());

          // Update the summary initially
          updateSummary();

          // Add the summary to the summary container
          containers.summary.appendChild(summary);
        });

        // When the submit button is clicked, submit the form
        submitButton.addEventListener('click', e => {
          e.preventDefault();
          // Validate the form
          const valid = TriageForm.validate(pathwayFieldset);
          // If the form is not valid, return
          if (!valid) return;

          // Submit the form
          TriageForm.submit({
            button: submitButton
          });
        });
      }

      // If there are fieldsets, the back button will take us to the previous fieldset
      if (HAS_CUSTOM_FORM_FIELD_GROUPS || HAS_PROGRESS) {
        // Add the next button to the fieldset
        pathwayFieldset.appendChild(backButton_forks);

        // Firstly, prevent the default action
        backButton_forks.addEventListener('click', e => e.preventDefault());

        // If there are fieldsets, the back button will take us to the previous fieldset
        if (fieldsets.length) {
          backButton_forks.addEventListener('click', () => FieldsetSteps.back());
        }

        // If there are no fieldsets, the back button will take us to the previous TriageSteps step
        else {
          backButton_forks.addEventListener('click', () => TriageSteps.back());
        }
      }

      // Add the fieldset to the steps
      FieldsetSteps.add({
        id: pathwayFieldset.id,
        element: pathwayFieldset,
        data
      });

      // If there were no fieldsets, we will set the FieldsetSteps to this fieldset
      if (!fieldsets.length) FieldsetSteps.goto(pathwayFieldset.id);

      // Add the form group to the steps
      TriageSteps.add({
        id: pathID,
        element: FormGroup_Pathway,
        data,
        FieldsetSteps
      });

      // Now we can go to the group
      TriageSteps.goto(pathID).catch(error => console.error(error));
    });
  });

  // Add the form element to the block
  containers.form.appendChild(TriageForm.element);

  // Remove the loading class from the form
  containers.form.classList.remove('loading');

  // Render the navigator
  TriageNavigator.render();
}

/* -------------------------------------------------------
Document Setup
------------------------------------------------------- */

// Loop all the triage form blocks
[...document.querySelectorAll('.js-default-triage')].forEach(block => {
  // TRIAGE_DATA_ARRAY.find((tree) => tree.block === block.id);
  const BLOCK_DATA_ID = block.id.split('_').pop();

  // Fetch the data and render the block
  fetch(`/api/get_triage_data?id=${BLOCK_DATA_ID}`).then(response => response.json()).then(r => renderTriageBlock(block, JSON.parse(r.data)));
});